<axis-modal
  class="nested size-large"
  #modalUIMUIReviewForm
>
  <axis-modal-header>
    <h1>Review State Forms</h1>
  </axis-modal-header>

  <axis-modal-content>
    @if (iframeUrl) {
      <iframe
        [src]="iframeUrl"
        width="100%"
        height="700px"
        style="border: none"
      ></iframe>
    }
  </axis-modal-content>
  <axis-modal-footer>
    <div class="axis-btn-wrapper">
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="kind-link"
          (click)="modalUIMUIReviewForm.close()"
        >
          <span class="axis-btn-icon-text">Close</span>
        </button>
      </div>
    </div>
  </axis-modal-footer>
</axis-modal>
